import { useState } from 'react';
import { TabPanel, Tabs } from '@/ui/Tabs';
import { GestionDeCompetencias } from './GestionDeCompetencias';
import { Matriz } from './Matriz';
import { MisCompetencias } from './MisCompetencias';

/**
 * Competencias — `#competencias`. Módulo 11, opción 4.
 *
 * Quien aprende ve lo suyo: lo que tiene, lo que le pide su cargo y los cursos
 * para cerrar la diferencia. Quien gestiona ve además la matriz por cargo y la
 * gestión de competencias, cursos y requisitos.
 *
 * ## Lo que cambia
 *
 * - **Quien gestiona también ve sus propias competencias.** El vanilla le
 *   enseñaba la matriz y la gestión, y nunca lo suyo: un coordinador no podía
 *   saber qué le pedía su cargo.
 * - Las pestañas del vanilla eran `role="tab"` sin flechas; aquí son las del
 *   sistema, que las tienen.
 * - Un fallo al cargar era un `alert-error` sin reintentar, en las tres vistas.
 *
 * El resto —la matriz, la vista propia, la gestión— cuenta lo suyo en su
 * archivo.
 */
export function Competencias() {
  // `cursos:manage` en el servidor, igual que el resto de Formación.
  const puedeGestionar = Auth.can('cursos', 'manage') || Auth.isStaff();
  const [pestana, setPestana] = useState('matriz');

  if (!puedeGestionar) {
    return (
      <>
        <header className="mb-4">
          <h1 className="flex items-center gap-2 text-6 font-bold text-brand-ink">
            <i className="bi bi-diagram-3-fill" aria-hidden="true" /> Mis competencias
          </h1>
        </header>
        <MisCompetencias />
      </>
    );
  }

  return (
    <>
      <header className="mb-4">
        <h1 className="flex items-center gap-2 text-6 font-bold text-brand-ink">
          <i className="bi bi-diagram-3-fill" aria-hidden="true" /> Competencias
        </h1>
        <p className="mt-1 text-3 text-muted">
          Qué cursos desarrollan cada competencia, qué cargos la piden y cuánta gente la tiene ya.
        </p>
      </header>

      <Tabs
        valor={pestana}
        onCambio={setPestana}
        pestanas={[
          { clave: 'matriz', etiqueta: 'Brechas por cargo', icono: 'bi-grid-3x3-gap' },
          { clave: 'gestion', etiqueta: 'Gestión', icono: 'bi-sliders' },
          { clave: 'mias', etiqueta: 'Mis competencias', icono: 'bi-person-check' },
        ]}
      >
        <TabPanel clave="matriz"><Matriz onIrAGestion={() => setPestana('gestion')} /></TabPanel>
        <TabPanel clave="gestion"><GestionDeCompetencias /></TabPanel>
        <TabPanel clave="mias"><MisCompetencias /></TabPanel>
      </Tabs>
    </>
  );
}
